import { useQuery } from "react-query";
import { _AccountApi } from "api/account/account";

export const useFAQ = () => {
  const { data, isLoading } = useQuery(
    ["faq"],
    () => _AccountApi.faq().then((res) => res),
    {
      keepPreviousData: true,
    }
  );
  return {
    data,
    isLoading,
  };
};
